import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from "@angular/router";
import {ContentService} from "../../services/content.service";
import {Subscription} from "rxjs";
import {Melody} from "../../model/melody";
import {AudioService} from "../../services/audio.service";
import {DeviceService} from "../../services/device.service";
import {SubscriberService} from "../../services/subscriber.service";
import {ContentStatus} from "../../model/content-status";
import {MainPageBanner} from "../../model/main-page-banner";

declare var $: any;

@Component({
  selector: 'app-melody-page',
  templateUrl: './melody-page.component.html',
  styleUrls: ['./melody-page.component.css'],
  host: {
    class: 'app-page'
  }
})
export class MelodyPageComponent implements OnInit, OnDestroy {
  @ViewChild("progressBar") private progressBar: ElementRef;

  melodyId: number;
  melody: Melody;

  recommendedMelodies: ReadonlyArray<Melody>;

  purchased: boolean;
  purchaseInProgress: boolean;
  progressBarInitialized: boolean;

  pageSize: number;

  subscription: Subscription;
  mainPageSpecialBanners: ReadonlyArray<MainPageBanner>;

  constructor(private readonly route: ActivatedRoute,
              private readonly router: Router,
              private readonly contentService: ContentService,
              private audioService: AudioService,
              private readonly location: Location,
              readonly deviceService: DeviceService,
              private readonly subscriberService: SubscriberService) {
    this.purchased = false;
    this.purchaseInProgress = false;
    this.progressBarInitialized = false;

    this.pageSize = deviceService.melodyPageMelodiesSize;

    this.subscription = new Subscription();
    this.mainPageSpecialBanners = [];
  }

  ngOnInit(): void {
    this.subscription.add(
      this.route.params.subscribe(params => {
        this.melodyId = parseInt(params['id']);

        this.loadMelody();
      })
    );

    this.subscription.add(
      this.subscriberService.subscriberMelodies.subscribe(() => this.checkSubscriberMelodies())
    );

    this.subscription.add(
      this.contentService.mainPageSpecialBanners.subscribe(banners => this.mainPageSpecialBanners = banners)
    )

    this.subscription.add(
      this.audioService.getState()
        .subscribe(state => {
          if (state.isPlaying && this.melody.isPlaying) {
            this.initProgressBar();

            if (state.currentTime && state.duration && this.progressBarInitialized) {
              $(this.progressBar.nativeElement).circleProgress('value', Number(state.currentTime) / Number(state.duration));
            }
          } else {
            this.destroyProgressBar();
          }
        })
    );

    this.subscription.add(
      this.subscriberService.favoriteMelodiesIds.subscribe(melodies => {
        if (melodies && this.melody) {
          this.melody.favorite = melodies.filter(melodyId => melodyId == this.melody?.id).length > 0;
        }
      })
    );
  }

  loadMelody(): void {
    if (this.melody && this.melody.isPlaying) {
      this.audioService.stopTrack();
      this.destroyProgressBar();
    }
    this.contentService.getMelodyById(this.melodyId)
      .subscribe(value => {
        if (value == null) {
          this.router.navigate(['error', '404']);
        } else {
          this.melody = value;
          this.checkSubscriberMelodies();
        }
      });

    this.contentService.getRecommendedMelodies(this.melodyId, this.pageSize)
      .subscribe(melodies => this.recommendedMelodies = melodies);
  }

  purchaseMelody(): void {
    if (!this.purchased && !this.purchaseInProgress) {
      this.subscriberService.purchaseMelodyPopup(this.melody);
    }
  }

  giftMelody(): void {
    this.subscriberService.giftMelodyPopup(this.melody);
  }

  toggleFavorite(): void {
    this.subscriberService.toggleFavorite(this.melody);
  }

  back(): void {
    this.location.back();
  }

  play(): void {
    this.audioService.togglePlay(this.melody);
  }

  initProgressBar(): void {
    if (!this.progressBarInitialized) {
      $(this.progressBar.nativeElement).circleProgress({
        startAngle: - Math.PI / 2,
        value: 0,
        animation: true,
        size: 57,
        fill: {color: "#191c22"},
        emptyFill: "#ffffff",
        lineCap: 'round',
        strokeLine: 28
      });
      this.progressBarInitialized = true;
    }
  }

  private destroyProgressBar(): void {
    if (this.progressBarInitialized) {
      const progressBar = $(this.progressBar.nativeElement);
      const circleProgress = progressBar.data('circle-progress');
      $(circleProgress.canvas).remove();
      progressBar.removeData('circle-progress');

      this.progressBarInitialized = false;
    }
  }

  private checkSubscriberMelodies(): void {
    let status = this.melody ? this.subscriberService.getSubscriberMelodyStatus(this.melody.id) : ContentStatus.NOT_FOUND;
    this.purchased = status == ContentStatus.ACTIVE;
    this.purchaseInProgress = status == ContentStatus.ACTIVATING || status == ContentStatus.DEACTIVATING;
  }

  ngOnDestroy(): void {
    if (this.melody && this.melody.isPlaying) {
      this.audioService.stopTrack();
    }
    if (this.progressBarInitialized) {
      this.destroyProgressBar();
    }
    this.subscription.unsubscribe();
  }
}
